// components/steps/BasicInfoStep.js
import React from 'react';
import { FileUpload } from '../components';

const BasicInfoStep = ({ formData, errors, isCheckingBalance, onInputChange, onFileUpload }) => {
    const handleFileUploadWrapper = (file, error, preview) => {
        if (error) {
            onInputChange('logo', null, { logo: error });
        } else {
            onInputChange('logo', file, null);
            onInputChange('logoPreview', preview, null);
        }
    };

    return (
        <div className="wrappermain">
            <div className="textformobile">
                <div className="parentmbl d-none">
                    <div className="parent">
                        <h6>Basic Info</h6>
                        <button>1/3</button>
                    </div>
                </div>
            </div>

            <FileUpload
                formData={formData}
                errors={errors}
                onFileUpload={handleFileUploadWrapper}
            />

            <div className="bottommainbox">
                <div className="innerbox">
                    <h2>Reward Token *</h2>
                    <input
                        placeholder="EVM address"
                        type="text"
                        value={formData.rewardToken}
                        onChange={(e) => onInputChange('rewardToken', e.target.value)}
                    />
                </div>
                {errors.rewardToken && <p className="error-text">{errors.rewardToken}</p>}
                {isCheckingBalance && <p className="info-text ">Checking balance...</p>}

                <div className="innerbox">
                    <h2>Chain</h2>
                    <input
                        disabled
                        placeholder="Select network"
                        type="text"
                        value={formData.chain || 'Etherscan'}
                        onChange={(e) => onInputChange('chain', e.target.value)}
                    />
                </div>

                <div className="innerbox">
                    <h2>Project Name *</h2>
                    <input
                        placeholder="Enter Project Name"
                        type="text"
                        value={formData.projectName}
                        onChange={(e) => onInputChange('projectName', e.target.value)}
                    />
                </div>
                {errors.projectName && <p className="error-text">{errors.projectName}</p>}

                <div className="innerbox">
                    <h2>Tagline *</h2>
                    <input
                        placeholder="Enter Tagline"
                        type="text"
                        value={formData.tagline}
                        onChange={(e) => onInputChange('tagline', e.target.value)}
                    />
                </div>
                {errors.tagline && <p className="error-text">{errors.tagline}</p>}

                <div className="innerbox forheight">
                    <h2>Pool Description</h2>
                    <input
                        placeholder="Enter Pool Description"
                        type="text"
                        value={formData.poolDescription}
                        onChange={(e) => onInputChange('poolDescription', e.target.value)}
                    />
                </div>
            </div>

            <h2 className="socials">Socials (Optional)</h2>
            <div className="bottommainbox">
                <div className="innerbox">
                    <h2>Project Website</h2>
                    <input
                        placeholder="https://example.com"
                        type="text"
                        value={formData.website}
                        onChange={(e) => onInputChange('website', e.target.value)}
                    />
                </div>
                {errors.website && <p className="error-text">{errors.website}</p>}

                <div className="innerbox">
                    <h2>Twitter/X Handle</h2>
                    <input
                        placeholder="@username (min 4 chars) or https://x.com/username"
                        type="text"
                        value={formData.twitter}
                        onChange={(e) => onInputChange('twitter', e.target.value)}
                    />
                </div>
                {errors.twitter && <p className="error-text">{errors.twitter}</p>}

                <div className="innerbox">
                    <h2>Instagram Handle</h2>
                    <input
                        placeholder="@username (min 3 chars) or https://instagram.com/username"
                        type="text"
                        value={formData.instagram}
                        onChange={(e) => onInputChange('instagram', e.target.value)}
                    />
                </div>
                {errors.instagram && <p className="error-text">{errors.instagram}</p>}

                <div className="innerbox">
                    <h2>Discord Handle</h2>
                    <input
                        placeholder="username (min 2 chars) or discord.gg/invite"
                        type="text"
                        value={formData.discord}
                        onChange={(e) => onInputChange('discord', e.target.value)}
                    />
                </div>
                {errors.discord && <p className="error-text">{errors.discord}</p>}
            </div>
        </div>
    );
};

export default BasicInfoStep;